export class ElementsClass {

    allElements:any = {
        Image:require('./image/Image').default,
        Video:require('./video/Video').default,
        Button: require('./button/Botton').default,
        RichText: require('./richText/RichText').default,
        Icon: require('./icon/Icon').default,
        Separator: require('./separator/Separator').default,
        Divider: require('./divider/Divider').default,
        RKPI: require('./rkpi/RKPI').default,
        AnimatedList: require('./animatedList/AnimatedList').default,
        MultipleButtons: require('./multipleButtons/MultipleButtons').default,
        Embedded: require('./embedded/Embedded').default,
        Chart: require('./chart/Chart').default
    };

    getElement(elementName:string) {
        return this.allElements[elementName];
    }

}

export default ElementsClass;

